import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Product } from '../shared/model/ui/product';
import { CmElement, ContentType } from '../shared/model/cm/managed-content.model';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { GlobalConstants } from '../shared/global-constants';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@Component({
selector: 'app-life-schedule-dollar',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './life-schedule-dollar.component.html',
  styleUrls: ['./life-schedule-dollar.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LifeScheduleDollarComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() parentForm: FormGroup;
  @Input() product: Product;

  public lifeAmountDollarElement: CmElement;
  public maxLengthAmount = GlobalConstants.MAX_LENGTH_AMOUNT;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public innerWidth: number = window.innerWidth;

  constructor(private fb: FormBuilder,
    private cmService: ManagedContentService,
    public formControlUtilitiesService: FormControlUtilitiesService
  ) { }

  ngOnInit(): void {

    if(this.parentForm){
      // If a control already exists (e.g. the page was just restored from
      // saved coverage selections in edit mode), preserve its value instead
      // of overwriting it with an empty one.
      const dollarKey = this.product.key + '_dollar';
      const existingDollar = this.parentForm.get(dollarKey);
      if (!existingDollar) {
        this.parentForm.addControl(dollarKey, this.fb.control('', [Validators.required]));
      } else {
        existingDollar.setValidators([Validators.required]);
        existingDollar.updateValueAndValidity({ emitEvent: false });
      }

      if(!this.parentForm.contains(this.product.key + '_schedule')){
        this.parentForm.addControl(this.product.key + '_schedule', this.fb.control('', [Validators.required]));
        this.parentForm.get(this.product.key + '_schedule').setValue('DOLLAR');
        this.parentForm.updateValueAndValidity();
      } else {
        this.parentForm.get(this.product.key + '_schedule').setValue('DOLLAR');
        this.parentForm.updateValueAndValidity();
      }
    }

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      this.innerWidth = window.innerWidth;
      this.loadManagedContent();
    });
  }//end ngOnInit

  ngOnDestroy(): void {
    if(this.parentForm){
      this.parentForm.removeControl(this.product.key + '_dollar');
    }
  }

  ngAfterViewInit(){
    this.innerWidth = window.innerWidth;
    this.loadManagedContent();
  }

  loadManagedContent() {
    if(this.innerWidth <= 425){
      this.lifeAmountDollarElement = this.cmService.getContentById(ContentType.ELEMENT, 'life-amount-dollar-sm');
    } else {
      this.lifeAmountDollarElement = this.cmService.getContentById(ContentType.ELEMENT, 'life-amount-dollar');
    }
  }

  handleInputFocusOut(key: string, value: string): void {
    this.parentForm.get(key).markAsTouched();
    //check if the user entered cents and remove them if so
    if(value != '0.00' && value.charAt(value.length - 3) === '.'){
      let trimmedValue = value.substring(0, value.length - 3);
      this.parentForm.get(key).setValue(trimmedValue);
    } else if(value == '0.00' || value == '0'){
      this.parentForm.get(key).hasError;
    }else {
      this.parentForm.get(key).setValue(value);
    }
  }
}
